export default (submitBtnSelector = null, autoSubmit = false) => {
    const selectors = {
        container: '.multi-input-pin',
        inputs: '.multi-input-pin__input',
        hidden: '#pin'
    };

    const multiInputPinContainer = document.querySelector(selectors.container);
    if (!multiInputPinContainer) return;

    const inputBoxes = [...multiInputPinContainer.querySelectorAll(selectors.inputs)];

    //on load clear all inputs
    inputBoxes.forEach(input => input.value = '');

    const hiddenPinInput = document.querySelector(selectors.hidden);
    const updateHiddenPin = () => {
        if (!hiddenPinInput) return;

        // Keep the real form field in sync because the visible PIN is split across multiple inputs.
        hiddenPinInput.value = inputBoxes.map(input => input.value).join('');
        if (!hiddenPinInput.value) {
            hiddenPinInput.value = '0'; //to avoid symfony validation issues
        }

        if (hiddenPinInput.value.length === inputBoxes.length && autoSubmit && submitBtnSelector) {
            const submitBtn = document.querySelector(submitBtnSelector);
            if (submitBtn) {
                //check if there is captcha and is already solved before enabling auto-submit
                const captchaInput = document.querySelector('[name="g-recaptcha-response"]');
                if (captchaInput && captchaInput.value) {
                    submitBtn.click();
                }
            }
        }
    };

    const fillFrom = (startIndex, rawValue) => {
        // Accept pasted or autofilled content, but keep only digits before distributing them.
        const digits = rawValue.replace(/\D/g, '').split('');
        if (!digits.length) return;

        digits.forEach((digit, offset) => {
            const input = inputBoxes[startIndex + offset];
            if (input) {
                input.value = digit;
            }
        });

        updateHiddenPin();

        const nextIndex = Math.min(startIndex + digits.length, inputBoxes.length - 1);
        if (inputBoxes[nextIndex]) {
            inputBoxes[nextIndex].focus();
        }
    };

    // Android clipboard / Gboard may insert the whole code via beforeinput instead of paste.
    multiInputPinContainer.addEventListener('beforeinput', (event) => {
        const currentIndex = inputBoxes.indexOf(event.target);
        if (currentIndex === -1) return;

        if (event.data && event.data.length > 1) {
            event.preventDefault();
            fillFrom(currentIndex, event.data);
        }
    });

    multiInputPinContainer.addEventListener('input', (event) => {
        const currentInput = event.target;
        const currentIndex = inputBoxes.indexOf(currentInput);
        if (currentIndex === -1) return;

        if (currentInput.value.length > 1) {
            fillFrom(currentIndex, currentInput.value);
            return;
        }

        currentInput.value = currentInput.value.replace(/\D/g, '');
        updateHiddenPin();

        // Move focus to next input if digit entered
        if (currentInput.value && currentIndex < inputBoxes.length - 1) {
            inputBoxes[currentIndex + 1].focus();
        }
    });

    // Handle backspace navigation
    multiInputPinContainer.addEventListener('keydown', (event) => {
        const currentInput = event.target;
        const currentIndex = inputBoxes.indexOf(currentInput);
        if (currentIndex === -1) return;

        if (event.key === 'Backspace') {
            if (!currentInput.value && currentIndex > 0) {
                // Match one-time-code UX: backspace on an empty cell moves left and clears the previous digit.
                inputBoxes[currentIndex - 1].value = '';
                inputBoxes[currentIndex - 1].focus();
                updateHiddenPin();
                event.preventDefault();
            }
        } else if (event.key === 'ArrowLeft' && currentIndex > 0) {
            inputBoxes[currentIndex - 1].focus();
            event.preventDefault();
        } else if (event.key === 'ArrowRight' && currentIndex < inputBoxes.length - 1) {
            inputBoxes[currentIndex + 1].focus();
            event.preventDefault();
        }
    });

    multiInputPinContainer.addEventListener('focusin', (event) => {
        if (event.target.tagName === 'INPUT') {
            // Delay selection slightly so mobile browsers finish applying focus first.
            setTimeout(() => event.target.select(), 10);
        }
    });

    // Handle paste code
    multiInputPinContainer.addEventListener('paste', (event) => {
        event.preventDefault();
        const currentInput = event.target;
        const startIndex = inputBoxes.indexOf(currentInput);
        if (startIndex === -1) return;

        const pastedValue = (event.clipboardData || window.clipboardData)?.getData('text') || '';
        fillFrom(startIndex, pastedValue);
    });

    inputBoxes.forEach(input => {
        // Hint to mobile browsers and password managers that this is a numeric one-time code.
        input.inputMode = 'numeric';
        input.setAttribute('pattern', '[0-9]*');
        input.setAttribute('autocomplete', 'one-time-code');
    });

    updateHiddenPin();
    if (inputBoxes[0]) {
        inputBoxes[0].focus();
    }


    //count down seconds from 2:00 to 0:00 until user can resend verification code
    let countdownInterval = null;
    const countdownElement = document.querySelector('#countdown');
    if (countdownElement) {
        let timeLeft = 119; // 2 minutes in seconds

        const updateCountdown = () => {
            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;
            countdownElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

            if (timeLeft > 0) {
                timeLeft -= 1;
            } else {
                clearInterval(countdownInterval);

                const resendBtn = document.getElementById("resend_btn");
                if (resendBtn) {
                    resendBtn.classList.remove("disabled");
                    resendBtn.classList.add("link-primary");
                }
            }
        };

        updateCountdown(); // Initialize immediately
        countdownInterval = setInterval(updateCountdown, 1000);
    }
};
